
import Python from "../../../assets/outline/Python.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PythonIcon({ className, dataTestid = "PythonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Python data-testid={dataTestid} className={classes} {...rest} />
  );
}
